// frontend/src/components/layout/BottomNavigation.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FaHome, FaUserCircle, FaRobot } from 'react-icons/fa';
import { SiBookstack } from "react-icons/si";
import { BsFillFileSlidesFill } from "react-icons/bs";
import { useAuthContext } from '../../context/AuthContext';
import { BsStars } from "react-icons/bs";


const BottomNavigation = () => {
    const { isLoggedIn, openAuthModal } = useAuthContext();
    const location = useLocation();

    const handleProfileClick = (e) => {
        if (!isLoggedIn) {
            e.preventDefault();
            openAuthModal();
        }
    };

    // کلاس پایه برای هر آیتم: فضا به طور مساوی تقسیم شود، رنگ پیش‌فرض gray-500
    const baseNavItemClass = "text-[28px] flex flex-1 flex-col items-center justify-center h-full text-gray-400 transition-all duration-200 py-1";
    // کلاس فعال برای متن/آیکون (متن و آیکون آبی می‌شوند)
    const activeNavItemClass = "text-sky-400";
    // آیکون فعال: فقط بزرگتر می‌شود (بدون دایره)
    const activeIconClass = "text-[28px]";

    return (
        <nav className="bottom-nav fixed bottom-2 left-1/2 -translate-x-1/2 w-[90%] max-w-[350px] md:max-w-[500px] h-[65px] bg-white shadow-[0_-2px_15px_rgba(0,0,0,0.2)] shadow-2xl rounded-full flex justify-between items-center px-2 z-[1000]">
            
            {/* کتابخانه */}
            <Link 
                to="/library" 
                className={`${baseNavItemClass} ${location.pathname.startsWith('/library') || location.pathname.startsWith('/books') ? activeNavItemClass : ''}`}
            >
                <SiBookstack className={`text-xl transition-all duration-200 ${location.pathname.startsWith('/library') || location.pathname.startsWith('/books') ? activeIconClass : ''}`} />
                <span className="text-[10px] md:text-[12px] font-medium mt-0.5">کتابخانه</span>
            </Link>
            
            {/* آثار (مالکیان) */}
            <Link 
                to="/Malekian" 
                className={`${baseNavItemClass} ${location.pathname === '/Malekian' ? activeNavItemClass : ''}`}
            >
                <FaHome className={`text-xl transition-all duration-200 ${location.pathname === '/Malekian' ? activeIconClass : ''}`} />
                <span className="text-[8px] md:text-[12px] font-medium mt-0.5">آثار</span>
            </Link>
            
            {/* درس‌گفتارها */}
            <Link 
                to="/" 
                className={`${baseNavItemClass} ${location.pathname === '/' ? activeNavItemClass : ''}`}
            > 
                <BsFillFileSlidesFill className={`text-xl transition-all duration-200 ${location.pathname === '/' ? activeIconClass : ''}`} />
                <span className="text-[8px] md:text-[12px] font-medium mt-0.5">درس‌گفتارها</span>
            </Link>

            {/* هوش مصنوعی */}
            <Link 
                to="/ai-assistant" 
                className={`${baseNavItemClass} ${location.pathname === '/ai-assistant' ? activeNavItemClass : ''}`}
            >
                <BsStars className={`text-xl transition-all duration-200 ${location.pathname === '/ai-assistant' ? activeIconClass : ''}`} />
                <span className="text-[8px] md:text-[12px] font-medium mt-0.5">دستیار هوشمند</span>
            </Link>
            
            {/* پروفایل */}
            <Link 
                to="/profile" 
                className={`${baseNavItemClass} ${location.pathname === '/profile' ? activeNavItemClass : ''}`}
                onClick={handleProfileClick}
            >
                <FaUserCircle className={`text-2xl transition-all duration-200 ${location.pathname === '/profile' ? activeIconClass : ''}`} />
                <span className="text-[8px] md:text-[12px] font-medium mt-0.5">پروفایل</span>
            </Link>
        </nav>
    );
};

export default BottomNavigation;